module.exports = __webpack_public_path__ + "static/img/red-envelopes-logo.716baa8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/red-envelopes-logo.png
// module id = VD5u
// module chunks = 1